export const registerInvitedInput = [
  {
    inputType: "text",
    prompt: "First Name",
    name: "firstName",
    placeholder: "Enter your first name",

    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 6,
        errorMessage: "Should be atleast 6 characters",
      },
    },
  },

  {
    inputType: "text",
    prompt: "Last Name",
    name: "lastName",
    placeholder: "Enter your last name",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 6,
        errorMessage: "Should be atleast 6 characters",
      },
    },
  },
  {
    inputType: "email",
    prompt: "Email",
    name: "email",
    placeholder: "Enter your email",
    fullWidth: false,
    rules: {
      validEmail: {
        expectedValue: true,
        errorMessage: "Invalid email",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Company Phone number",
    name: "phone",
    placeholder: "Enter the company's phone number",
    fullWidth: false,
    rules: {
      validNigerianPhoneNumber: {
        expectedValue: true,
        errorMessage: "Invalid Nigerian phone number",
      },
    },
  },

  {
    inputType: "password",
    prompt: "Password",
    name: "password",
    placeholder: "Enter password",
    fullWidth: false,
    rules: {
      compareWithExisting: {
        expectedValue: "password",
        errorMessage: "Does not match the password",
      },
    },
  },

  {
    inputType: "password",
    prompt: "Confirm Password",
    name: "confirmPassword",
    placeholder: "Confirm password",
    fullWidth: false,
  },
];
